{
    "(save {highestYearlyDiscount}%)": "(uštedite {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dana besplatno",
    "{amount} off": "{amount} popusta",
    "{amount} off for first {number} months.": "{amount} popusta za prvih {number} meseci.",
    "{amount} off for first {period}.": "{amount} popusta za prvi {period}.",
    "{amount} off forever.": "{amount} popusta zauvek.",
    "{discount}% discount": "{discount}% popusta",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} više neće dobijati {newsletterName} bilten.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} više neće dobijati email-ove kada neko odgovori na Vaše komentare.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} više neće dobijati ovaj bilten.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dana besplatno",
    "{years} years": "",
    "+1 (123) 456-7890": "+381 60 123-456",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Nalog",
    "Account details updated successfully": "Detalji naloga su uspešno ažurirani",
    "Account settings": "Podešavanja naloga",
    "Add a personal note": "Dodajte ličnu napomenu",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Nakon što istekne besplatan probni period, biće Vam naplaćena redovna cena za nivo koji ste odabrali. Uvek možete otkazati pre tog roka.",
    "Already a member?": "Već ste član?",
    "An error occurred": "Došlo je do greške",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Došlo je do neočekivane greške. Pokušajte ponovo ili <a>kontaktirajte podršku</a> ako greška potraje.",
    "Back": "Nazad",
    "Back to Log in": "Nazad na prijavu",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Crni petak",
    "Bluesky": "",
    "Cancel anytime.": "Otkažite u bilo kom trenutku.",
    "Cancel subscription": "Otkažite pretplatu",
    "Canceled": "",
    "Cancellation reason": "Razlog otkazivanja",
    "Change": "Promenite",
    "Change plan": "Promenite plan",
    "Check spam & promotions folders": "Proverite fascikle za neželjenu poštu i promocije",
    "Check with your mail provider": "Proverite sa Vašim mail provajderom",
    "Check your inbox to verify email update": "Proverite Vaš inbox da verifikujete promenu email-a",
    "Choose": "Izaberite",
    "Choose a different plan": "Izaberite drugi plan",
    "Choose a plan": "Izaberite plan",
    "Choose your newsletters": "Izaberite svoje biltene",
    "Click here to retry": "Kliknite ovde da pokušate ponovo",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zatvorite",
    "Code": "Kod",
    "Comment preferences updated.": "Preference komentara ažurirane.",
    "Comments": "Komentari",
    "Complimentary": "Besplatno",
    "Confirm": "Potvrdite",
    "Confirm cancellation": "Potvrdite otkazivanje",
    "Confirm subscription": "Potvrdite pretplatu",
    "Contact support": "Kontaktirajte podršku",
    "Continue": "Nastavite",
    "Continue subscription": "Nastavite pretplatu",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "Nije moguće kreirati sesiju Stripe portala naplate",
    "Could not create Stripe checkout session": "Nije moguće kreirati sesiju plaćanja pomoću Stripe-a",
    "Could not sign in. Login link expired.": "Nije moguće prijaviti se. Link za prijavu je istekao.",
    "Could not update email! Invalid link.": "Nije moguće ažurirati email! Nevalidan link.",
    "Create a new contact": "Napravite novi kontakt",
    "Current plan": "Trenutni plan",
    "Delete account": "Obrišite nalog",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Niste želeli ovo da uradite? Upravljajte svojim preferencama <button>ovde</button>.",
    "Don't have an account?": "Nemate nalog?",
    "Edit": "Uredite",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email newsletter": "Email bilten",
    "Email newsletter settings updated": "Podešavanja email biltena ažurirana.",
    "Email preferences": "Preference za email",
    "Email preferences updated.": "Preference za email ažurirane.",
    "Emails": "Email-ovi",
    "Emails disabled": "Email-ovi onemogućeni",
    "Ends {offerEndDate}": "Završava se {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "Unesite kod iznad",
    "Enter your email address": "Unesite Vašu email adresu",
    "Enter your name": "Unesite Vaše ime",
    "Error": "Greška",
    "Expires {expiryDate}": "Ističe {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Neuspešno otkazivanje pretplate, pokušajte ponovo",
    "Failed to log in, please try again": "Neuspešna prijava, pokušajte ponovo",
    "Failed to log out, please try again": "Neuspešno odjavljivanje, pokušajte ponovo",
    "Failed to open billing portal, please try again": "Neuspešno otvaranje portala naplate, pokušajte ponovo",
    "Failed to process checkout, please try again": "Neuspešna obrada plaćanja, pokušajte ponovo",
    "Failed to send magic link email": "Neuspešno slanje email-a sa magičnim linkom",
    "Failed to send verification email": "Neuspešno slanje verifikacionog email-a",
    "Failed to sign up, please try again": "Neuspešna registracija, pokušajte ponovo",
    "Failed to update account data": "Neuspešno ažuriranje podataka naloga",
    "Failed to update account details": "Neuspešno ažuriranje detalja naloga",
    "Failed to update billing information, please try again": "Neuspešno ažuriranje informacija o naplati, pokušajte ponovo",
    "Failed to update newsletter settings": "Neuspešno ažuriranje podešavanja biltena",
    "Failed to update subscription, please try again": "Neuspešno ažuriranje pretplate, pokušajte ponovo",
    "Failed to verify code, please try again": "Neuspešna verifikacija koda, pokušajte ponovo",
    "Forever": "Zauvek",
    "Free Trial – Ends {trialEnd}": "Besplatan probni period – Završava se {trialEnd}",
    "Get help": "Zatražite pomoć",
    "Get in touch for help": "Kontaktirajte nas za pomoć",
    "Get notified when someone replies to your comment": "Primite obaveštenje kada neko odgovori na Vaš komentar",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Dajte povratnu informaciju o ovoj objavi",
    "Help! I'm not receiving emails": "Pomoć! Ne primam email-ove",
    "Here are a few other sites you may enjoy.": "Evo nekoliko drugih sajtova koji Vam mogu biti zanimljivi.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ako je bilten označen kao neželjena pošta, email-ovi su automatski onemogućeni za tu adresu kako biste prestali primati neželjene poruke.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ako je žalba za neželjenu poštu bila slučajna ili želite ponovo da primate email-ove, možete se ponovo pretplatiti klikom na dugme na prethodnom ekranu.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ako sada otkažete pretplatu imaćete pristup do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ako imate korporativni ili vladin email nalog, obratite se svom IT odeljenju i zamolite ih da dozvole primanje email-ova od {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Link za prijavu je poslat u Vaš inbox. Ako ne stigne u roku od 3 minuta, proverite fasciklu za neželjenu poštu.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "Email je poslat na {submittedEmailOrInbox}. Kliknite na link unutar njega ili unesite kod ispod.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ako želite ponovo da primate email-ove, najbolji naredni koraci su da proverite adresu email-a u datoteci za bilo kakve probleme i potom kliknete na ponovnu pretplatu na prethodnom ekranu.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ako ne primate email bilten na koji ste se pretplatili, evo nekoliko stvari koje treba proveriti.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ako ste završili sve ove korake i još uvek ne primate email-ove, možete zatražiti pomoć kontaktiranjem {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "U slučaju da dođe do trajnog kvara prilikom slanja biltena, email-ovi će biti onemogućeni na nalogu.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Dodajte {senderEmail} u svoju listu kontakata u email klijentu. Ovo signalizira Vašem mail provajderu da treba verovati porukama poslatim sa ove adrese.",
    "Invalid email address": "Nevalidna email adresa",
    "Invalid verification code": "Nevalidan verifikacioni kod",
    "Jamie Larson": "Pera Perić",
    "jamie@example.com": "pera@example.com",
    "Less like this": "Manje nalik na ovo",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Uverite se da email-ovi slučajno ne završavaju u fasciklama za neželjenu poštu ili promocije u Vašem inbox-u. Ako jesu, kliknite na „Označi kao da nije neželjeno“ i/ili „Premesti u inbox“.",
    "Manage": "Upravljajte",
    "Maybe later": "Možda kasnije",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Članstva sa ovog email domena su trenutno ograničena.",
    "Memberships unavailable, contact the owner for access.": "Članstva nisu dostupna, kontaktirajte vlasnika radi pristupa.",
    "month": "mesec",
    "Monthly": "Mesečno",
    "More like this": "Više nalik na ovo",
    "More options": "",
    "Name": "Ime",
    "Need more help? Contact support": "Treba Vam više pomoći? Kontaktirajte podršku",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Bilteni mogu biti onemogućeni na Vašem nalogu iz dva razloga: prethodni email je označen kao neželjena pošta ili je pokušaj slanja email-a rezultirao trajnim neuspehom (odbijeno).",
    "No member exists with this e-mail address.": "Ne postoji član sa ovom email adresom.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ne primate email-ove?",
    "Now check your email!": "Sada proverite svoj email!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Kada se ponovo pretplatite, ako i dalje ne vidite email-ove u svom inbox-u, proverite fasciklu za neželjenu poštu. Neki inbox provajderi čuvaju zapise o prethodnim žalbama na neželjenu poštu i nastaviće da označavaju email-ove. Ako se to desi, označite najnoviji bilten kao 'Nije neželjeno' da ga premestite nazad u svoj inbox.",
    "Open AOL Mail": "Otvorite AOL Mail",
    "Open email": "Otvorite email",
    "Open Feedbin": "",
    "Open Gmail": "Otvorite Gmail",
    "Open Hey": "Otvorite Hey",
    "Open iCloud Mail": "Otvorite iCloud Mail",
    "Open Mail.ru": "Otvorite Mail.ru",
    "Open Outlook": "Otvorite Outlook",
    "Open Proton Mail": "Otvorite Proton Mail",
    "Open Yahoo Mail": "Otvorite Yahoo Mail",
    "Permanent failure (bounce)": "Trajni neuspeh (odbijeno)",
    "Phone number": "Broj telefona",
    "Plan": "Plan",
    "Plan checkout was cancelled.": "Plaćanje plana je otkazano.",
    "Plan upgrade was cancelled.": "Nadogradnja plana je otkazana.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Kontaktirajte {supportAddress} da podesite Vašu besplatnu pretplatu.",
    "Please enter {fieldName}": "Molimo Vas unesite {fieldName}",
    "Please fill in required fields": "Molimo Vas popunite obavezna polja",
    "Podcasts": "",
    "Re-enable emails": "Ponovo omogućite email-ove",
    "Recommendations": "Preporuke",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Obnavlja se po ceni od {price}.",
    "Resume subscription": "",
    "Retry": "Pokušajte ponovo",
    "Save": "Sačuvajte",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Slanje linka za prijavu...",
    "Sending...": "Slanje...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Prikažite sve",
    "Sign in": "Prijavite se",
    "Sign out": "Odjavite se",
    "Sign up": "Registrujte se",
    "Signup error: Invalid link": "Greška pri registraciji: Nevalidan link",
    "Signups from this email domain are currently restricted.": "Registracije sa ovog email domena su trenutno ograničene.",
    "Something went wrong, please try again later.": "Nešto je pošlo naopako, molimo Vas pokušajte kasnije.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Izvinite, ali preporuke trenutno nisu dostupne.",
    "Sorry, that didn’t work.": "Izvinite, to nije uspelo.",
    "Spam complaints": "Žalbe na neželjenu poštu",
    "Start {amount}-day free trial": "Započnite {amount}-dnevni besplatni probni period",
    "Starting {startDate}": "Počinje {startDate}",
    "Starting today": "Počinje danas",
    "Submit feedback": "Pošaljite povratnu informaciju",
    "Subscribe": "Pretplatite se",
    "Subscribed": "Pretplaćeno",
    "Subscription plan updated successfully": "Plan pretplate je uspešno ažuriran",
    "Success": "Uspešno",
    "Success! Check your email for magic link to sign-in.": "Uspešno! Proverite Vaš email za magični link za prijavu.",
    "Success! Your account is fully activated, you now have access to all content.": "Uspešno! Vaš nalog je potpuno aktiviran, sada imate pristup svim sadržajima.",
    "Success! Your email is updated.": "Uspešno! Vaš email je ažuriran.",
    "Successfully unsubscribed": "Uspešno ste se odjavili",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Hvala Vam što ste se pretplatili. Pre nego što počnete sa čitanjem, u nastavku su neki drugi sajtovi koji bi Vam mogli biti zanimljivi.",
    "Thank you for your support": "Hvala Vam na podršci",
    "Thank you for your support!": "Hvala Vam na podršci!",
    "Thanks for the feedback!": "Hvala na povratnoj informaciji!",
    "That didn't go to plan": "To nije išlo po planu",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Email adresa koju imamo za Vas je {memberEmail} — ako to nije tačno, možete je ažurirati u <button>postavkama naloga</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Došlo je do problema pri slanju Vaše povratne informacije. Molimo Vas pokušajte kasnije.",
    "There was an error cancelling your subscription, please try again.": "Došlo je do greške pri otkazivanju Vaše pretplate, pokušajte ponovo.",
    "There was an error continuing your subscription, please try again.": "Došlo je do greške pri nastavku Vaše pretplate, pokušajte ponovo.",
    "There was an error processing your payment. Please try again.": "Došlo je do greške pri obradi Vaše uplate. Molimo Vas pokušajte ponovo.",
    "There was an error sending the email, please try again": "Došlo je do greške pri slanju email-a, pokušajte ponovo.",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Ovaj sajt je samo na poziv, kontaktirajte vlasnika radi pristupa.",
    "This site is not accepting donations at the moment.": "Ovaj sajt trenutno ne prima donacije.",
    "This site is not accepting payments at the moment.": "Ovaj sajt trenutno ne prihvata uplate.",
    "This site only accepts paid members.": "Ovaj sajt prihvata samo plaćene članove.",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Da biste završili registraciju, kliknite na link za potvrdu u inbox-u. Ako ne stigne u roku od 3 minuta, proverite fasciklu za neželjenu poštu!",
    "To continue to stay up to date, subscribe to {publication} below.": "Da biste ostali u toku, pretplatite se na {publication} u nastavku.",
    "Too many attempts try again in {number} days.": "Previše pokušaja, pokušajte ponovo za {number} dana.",
    "Too many attempts try again in {number} hours.": "Previše pokušaja, pokušajte ponovo za {number} sati.",
    "Too many attempts try again in {number} minutes.": "Previše pokušaja, pokušajte ponovo za {number} minuta.",
    "Too many different sign-in attempts, try again in {number} days": "Previše različitih pokušaja prijavljivanja, pokušajte ponovo za {number} dana",
    "Too many different sign-in attempts, try again in {number} hours": "Previše različitih pokušaja prijavljivanja, pokušajte ponovo za {number} sati",
    "Too many different sign-in attempts, try again in {number} minutes": "Previše različitih pokušaja prijavljivanja, pokušajte ponovo za {number} minuta",
    "Too many sign-up attempts, try again later": "Previše pokušaja registracije, pokušajte ponovo kasnije",
    "Try free for {amount} days, then {originalPrice}.": "Probajte besplatno za {amount} dana, nakon toga {originalPrice}.",
    "Unable to initiate checkout session": "Nije moguće pokrenuti sesiju plaćanja",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Otključajte pristup svim biltenima tako što ćete postati plaćeni pretplatnik.",
    "Unsubscribe from all emails": "Odjavite se sa svih email-ova",
    "Unsubscribed": "Odjavljeni",
    "Unsubscribed from all emails.": "Odjavljeni sa svih email-ova.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Odjavljivanje sa email-ova neće otkazati Vašu plaćenu pretplatu na {title}",
    "Update": "Ažurirajte",
    "Update your preferences": "Ažurirajte svoje preference",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Link za verifikaciju je poslat, proverite Vaš inbox",
    "Verify your email address is correct": "Proverite da li je Vaša email adresa ispravna",
    "Verifying...": "Verifikacija...",
    "View plans": "Pogledajte planove",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nismo mogli da Vas odjavimo jer email adresa nije pronađena. Molimo Vas da kontaktirate vlasnika sajta.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Dobro došli nazad, {name}!",
    "Welcome back!": "Dobro došli nazad!",
    "Welcome to {siteTitle}": "Dobro došli na {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Kada inbox ne prihvata email, to se obično naziva odbijanje. U mnogim slučajevima to može biti privremeno. Međutim, u nekim slučajevima, odbijeni email može biti vraćen kao trajni neuspeh ako je email adresa nevalidna ili nepostojeća.",
    "Why has my email been disabled?": "Zašto je moj email onemogućen?",
    "X (Twitter)": "",
    "year": "godina",
    "Yearly": "Godišnje",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Trenutno imate besplatno članstvo, nadogradite na plaćenu pretplatu za puni pristup.",
    "You have been successfully resubscribed": "Uspešno ste ponovo pretplaćeni",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Trenutno ne primate email-ove",
    "You're not receiving emails": "Ne primate email-ove",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ne primate email-ove jer ste ili označili nedavno primljenu poruku kao neželjenu, ili poruke nisu mogle biti isporučene na Vašu email adresu.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Uspešno ste se prijavili.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Uspešno ste se pretplatili na <strong>{siteTitle}</strong>",
    "Your account": "Vaš nalog",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Ponovna pretplata na Vaš email nije uspela, pokušajte ponovo",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "Vaš inbox",
    "Your input helps shape what gets published.": "Vaše učešće pomaže u oblikovanju onoga što će biti objavljeno.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Vaša pretplata ističe {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Vaša pretplata će biti obnovljena {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Vaša pretplata će početi {subscriptionStart}"
}
